import {AppPermissions} from '@shared/constants/Mapping';
import {State} from '@shared/store/reducers/Index';
import {useSelector} from 'react-redux';

export const useSmartCoderPermission = ({
  objectFunction = 'READ'
}: {
  objectFunction: string;
}): boolean => {
  const {userPermissions, groupId} = useSelector((state: State) => state.auth);

  const doesUserHavePermission =
    !!groupId &&
    !!userPermissions?.[groupId]?.[AppPermissions['SMART_CODER'].NAME]?.[
      AppPermissions['SMART_CODER'][objectFunction]
    ];
  return doesUserHavePermission;
};
